(function () {
    'use strict';

    angular
        .module('app')
        .controller('documentDashboardOptions', documentDashboardOptions);

    documentDashboardOptions.$inject = ['documentDashboardService', '$mdDialog', '$filter', 'loginService'];

    function documentDashboardOptions(documentDashboardService, $mdDialog, $filter, loginService) {
        var vm = this;

        vm.documentDashboardOptionsLabel = loginService.resourceStrings["DOCUMENT_DASHBOARD_DISPLAY"]; // "Document Dashboard Display and Virtual Library Population"
        vm.documentDashboardOptionsDetailLabel = loginService.resourceStrings["DOCUMENT_DASHBOARD_DISPLAY_DETAIL"]; // "Options to speed up loading of Document Dashboard"

        vm.stopAtAutoCad = loginService.resourceStrings["STOP_AT_AUTOCAD_OVERLAYS"]; // "Stop at AutoCAD Overlays";
        vm.stopAtSolidworks = loginService.resourceStrings["STOP_AT_SOLIDWORKS_IN_CONTEXT"]; // "Stop at Solidworks In Context Relationships";
        vm.stopAtInventor = loginService.resourceStrings["STOP_AT_INVENTOR_SUBSTITUTE"]; // "Stop at Inventor Substitute References";
        vm.stopAtMicrostation = loginService.resourceStrings["STOP_AT_MICROSTATION_NO_NESTING"]; // "Stop at Microstation No Nesting References";

        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"

        vm.informationSource = 1; // Not used on this settings page.
        vm.bStopAtAutoCad = false;
        vm.bStopAtSolidworks = false;
        vm.bStopAtInventor = false;
        vm.bStopAtMicrostation = false;

        vm.changed = false;
        activate();
        vm.documentDashboardService = documentDashboardService;
        vm.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"

        //TD 06-26-2018 (25482) Options for AutoCAD and SOLIDWORKS were switched.
        documentDashboardService.getUserOptions().then(function (data) {
            if (data != null) {
                vm.informationSource = data.InformationSource;
                vm.bStopAtAutoCad = data.StopAtOverlays; //data.StopAtInContext;
                vm.bStopAtSolidworks = data.StopAtInContext; //data.StopAtOverlays;
                vm.bStopAtInventor = data.StopAtSubstitute;
                vm.bStopAtMicrostation = data.StopAtNesting;
            }
        });

        //when the ok button is clicked
        vm.onOk = function () {
            //set the fields
            var userOptions = {
                InformationSource: vm.informationSource,
                StopAtInContext: vm.bStopAtSolidworks, //vm.bStopAtAutoCad,
                StopAtOverlays: vm.bStopAtAutoCad, //vm.bStopAtSolidworks,
                StopAtSubstitute: vm.bStopAtInventor,
                StopAtNesting: vm.bStopAtMicrostation,
            }

            documentDashboardService.setUserOptions(userOptions).then(function () {
                $mdDialog.hide();
            })
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }

        function activate() { }
    }
})();
